import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Sparkles } from "lucide-react";

/**
 * Varianter:
 *   variant="stripe"        – full bredde, kompakt – brukes på dashboard / nederst på Skapere
 *   variant="card"          – vertikalt sidekort
 *   variant="footer"        – kort tekst-lenke i blå – brukes i Layout-footer
 *   variant="thread-row"    – passer som tråd-rad i forum-listing
 *   variant="contest-card"  – passer som kort i konkurranser-grid
 */
export default function OnlyFansAdStripe({ variant = "stripe" }) {
  const { t } = useTranslation();
  const dataAttr = `of-ad-${variant}`;

  if (variant === "footer") {
    return (
      <Link
        to="/bli-onlyfans-skaper"
        data-testid={dataAttr}
        className="hover:text-[var(--cream)]"
        style={{ color: "#5BA5C9" }}
      >
        {t("footer.become_onlyfans_creator", "Bli OnlyFans-skaper")}
      </Link>
    );
  }

  if (variant === "thread-row") {
    return (
      <li className="of-ad-thread-wrap">
        <Link
          to="/bli-onlyfans-skaper"
          data-testid={dataAttr}
          className="of-ad-thread"
        >
          <div className="of-ad-thread-main">
            <div className="of-ad-thread-tag">
              <Sparkles className="h-3 w-3" /> {t("of_ad.sponsored")} · {t("of_ad.coaching")}
            </div>
            <h3>{t("of_ad.headline")}</h3>
            <div className="of-ad-thread-meta">
              {t("of_ad.thread_meta")}
            </div>
          </div>
          <span className="of-ad-thread-cta">
            {t("of_ad.read_more")} <ArrowRight className="h-3.5 w-3.5" />
          </span>
        </Link>
      </li>
    );
  }

  if (variant === "contest-card") {
    return (
      <Link
        to="/bli-onlyfans-skaper"
        data-testid={dataAttr}
        className="of-ad-contest"
      >
        <div className="of-ad-contest-tag">
          <Sparkles className="h-3 w-3" /> {t("of_ad.sponsored")}
        </div>
        <div className="of-ad-contest-art">
          <span style={{ fontSize: "3rem", fontWeight: 300, color: "#5BA5C9", letterSpacing: "0.05em" }}>OF</span>
        </div>
        <div className="of-ad-contest-body">
          <div className="font-meta text-[10px] tracking-[0.2em] mb-2" style={{ color: "#5BA5C9" }}>
            {t("of_ad.coaching").toUpperCase()}
          </div>
          <h3>{t("of_ad.headline")}</h3>
          <div className="of-ad-contest-meta">
            {t("of_ad.contest_meta")}
          </div>
        </div>
      </Link>
    );
  }

  if (variant === "card") {
    return (
      <Link
        to="/bli-onlyfans-skaper"
        data-testid={dataAttr}
        className="of-ad of-ad-card"
      >
        <span className="of-ad-pill">
          <span className="dot" style={{ width: 6, height: 6, background: "#5BA5C9", borderRadius: "50%" }} />
          {t("of_ad.tag_own_start")}
        </span>
        <h3 dangerouslySetInnerHTML={{ __html: t("of_ad.headline_break") }} />
        <p>{t("of_ad.card_lead")}</p>
        <span className="of-cta">
          {t("of_ad.read_more")} <ArrowRight className="h-3.5 w-3.5" />
        </span>
      </Link>
    );
  }

  // Default: stripe
  return (
    <Link
      to="/bli-onlyfans-skaper"
      data-testid={dataAttr}
      className="of-ad of-ad-stripe"
    >
      <div style={{ minWidth: 0 }}>
        <span className="of-ad-pill">
          <span style={{ width: 6, height: 6, background: "#5BA5C9", borderRadius: "50%", display: "inline-block" }} />
          {t("of_ad.coaching")}
        </span>
        <h3 style={{ marginTop: "0.75rem" }}>
          {t("of_ad.headline")}
        </h3>
        <p>{t("of_ad.stripe_lead")}</p>
      </div>
      <span className="of-cta">
        {t("of_ad.read_more")} <ArrowRight className="h-3.5 w-3.5" />
      </span>
    </Link>
  );
}
